module.exports = __webpack_public_path__ + "static/media/chart-scatter.ee194d30.svg";